import React from 'react';
import { RefreshCw, UserPlus } from 'lucide-react';
import { Button } from '../ui/Button';
import { DjayAvatar } from '../../mascot';
interface DemoBannerProps {
  onResetDemo: () => void;
  onRegister: () => void;
}
export function DemoBanner({
  onResetDemo,
  onRegister
}: DemoBannerProps) {
  return <div className="bg-gradient-to-r from-amber-100 to-orange-50 border-b border-amber-200 px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-4 z-50 relative shadow-sm" data-id="element-1410">
      <div className="flex items-center gap-3 text-amber-900 font-medium text-sm" data-id="element-1411">
        <div className="shrink-0 bg-white/60 rounded-full p-1 shadow-sm border border-amber-200/50" data-id="element-1412">
          <DjayAvatar size="xs" emotion="pointing" animate={false} data-id="element-1413" />
        </div>
        <div data-id="element-1414">
          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-black bg-amber-500 text-white uppercase tracking-wider mr-2 shadow-sm" data-id="element-1415">
            Demo Modus
          </span>
          <span className="opacity-90" data-id="element-1416">
            Je verkent de app met voorbeelddata
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-1417">
        <Button variant="ghost" size="sm" onClick={onResetDemo} className="flex-1 sm:flex-none text-amber-800 hover:bg-amber-200/50 hover:text-amber-900" data-id="element-1418">
          <RefreshCw className="w-4 h-4 mr-1.5" data-id="element-1419" />
          Reset
        </Button>
        <Button variant="danger" size="sm" onClick={onRegister} className="flex-1 sm:flex-none shadow-sm" data-id="element-1420">
          <UserPlus className="w-4 h-4 mr-1.5" data-id="element-1421" />
          Account maken
        </Button>
      </div>
    </div>;
}